export const normalizeOptionalText = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }

  const normalizedValue: string = String(value).trim();
  return normalizedValue.toLowerCase() === 'undefined' ? '' : normalizedValue;
};
